import { optionsToProductMapping } from './quizStaticMapping';
import { validateProduct } from './quizResults';

const generateProductsWithoutDev = (steps, currentStep, tools) => {
  return unionWithoutDev(steps, currentStep, tools);
};

const unionWithoutDev = (steps, currentStep, tools) => {
  let user = [],
    extras = [];
  for (let i = 1; i <= currentStep; i++) {
    let optionsForStep = steps[i];
    optionsForStep.forEach(option => {
      optionsToProductMapping[option].forEach(product => {
        let isValidProduct = validateProduct(tools, product);
        if (isValidProduct) {
          if (
            optionsToProductMapping.extras.includes(product) &&
            !extras.includes(product)
          ) {
            extras.push(product);
          }
          if (!user.includes(product) && !extras.includes(product)) {
            user.push(product);
          }
        }
      });
    });
  }
  return { user, extras };
};

export { generateProductsWithoutDev, unionWithoutDev };
